import { Action } from '@ngrx/store'

import { VendorUserV1 } from '../../../../api/api/models/vendor-user-v1'
import { ChangePasswordModel } from '../../../../api/identity/models/change-password-model'
import { RegistrationModel } from '../../../../api/identity/models/registration-model'

export const CREATE_USER = '[TeamUser] Create user'

export const LOAD_USERS = '[TeamUser] Load users'
export const LOAD_USERS_SUCCESS = '[TeamUser] Load users success'

export const LOAD_CREATED_USER = '[TeamUser] Load created user'
export const LOAD_CREATED_USER_SUCCESS = '[TeamUser] Load created user success'

export const UPDATE_USER = '[TeamUser] Update user'
export const UPDATE_USER_SUCCESS = '[TeamUser] Update user success'
export const CHANGE_USER_PASSWORD = '[TeamUser] Change user password'

export class LoadUsers implements Action {
  readonly type = LOAD_USERS
}

export class LoadUsersSuccess implements Action {
  readonly type = LOAD_USERS_SUCCESS

  constructor(public payload: { users: VendorUserV1[] }) {
  }
}

export class LoadCreatedUser implements Action {
  readonly type = LOAD_CREATED_USER

  constructor(public payload: { email: string, vendorTeamId: number }) {
  }
}

export class LoadCreatedUserSuccess implements Action {
  readonly type = LOAD_CREATED_USER_SUCCESS

  constructor(public payload: { user: VendorUserV1 }) {
  }
}

export class CreateUser implements Action {
  readonly type = CREATE_USER

  constructor(public payload: RegistrationModel) {
  }
}

export class ChangeUserPassword implements Action {
  readonly type = CHANGE_USER_PASSWORD

  constructor(public payload: ChangePasswordModel) {
  }
}

export class UpdateUser implements Action {
  readonly type = UPDATE_USER

  constructor(public payload: { user: VendorUserV1 }) {
  }
}

export class UpdateUserSuccess implements Action {
  readonly type = UPDATE_USER_SUCCESS

  constructor(public payload: { user: VendorUserV1 }) {
  }
}

export type UsersActions =
  LoadUsers
  | LoadUsersSuccess
  | CreateUser
  | ChangeUserPassword
  | UpdateUser
  | UpdateUserSuccess
  | LoadCreatedUser
  | LoadCreatedUserSuccess



// WEBPACK FOOTER //
// ./src/app/shared/team/store/actions/users.actions.ts